import { render, staticRenderFns } from "./NBCollectorManage.vue?vue&type=template&id=3f50c511&"
import script from "./NBCollectorManage.vue?vue&type=script&lang=js&"
export * from "./NBCollectorManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports